import { useNotifications, useReadNotification } from '../../../Features/notifications/hooks/useNotifications';
import type { NotificationData } from '../../../Features/notifications/api/notifications.api';
import React, { useState } from 'react'
import { Badges, H3, H5, H6, LI, P, UL } from '../../../AbstractElements'
import { Href, NotificationTitle } from '../../../Utils/Constants';
import { notificationData } from '../../../Data/Layout/RightHeader';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';
import { Link } from 'react-router-dom';


export default function Notification() {
    const { data } = useNotifications();
    const readNotification = useReadNotification();
    const [notifyDropdown, setNotifyDropdown] = useState(false);
    const toggle = () => setNotifyDropdown((prevState) => !prevState);
    const notifications = Array.isArray(data?.list) ? (data?.list ?? []) : [];
    const totalNotification = notifications.filter(notification => notification.read_in === 0).length;

    const handleNotificationClick = (notification: NotificationData) => {
    if (notification.read_in === 0) {
            readNotification.mutate(notification.ID);
        }
        setNotifyDropdown(false);
    };        

    return (
        <LI className="custom-dropdown">
            <button onClick={toggle} type='button' className='border-0 bg-transparent p-0'>
                <SvgIcon iconId="notification" />
            </button>

            {totalNotification > 0 && (
                <Badges color='primary' pill>{totalNotification}</Badges>
            )}
            <div className={`custom-menu notification-dropdown py-0 overflow-hidden ${notifyDropdown ? 'show' : ''}`}>
                <H3 className="title bg-primary-light dropdown-title">{NotificationTitle} 
                    {/* <span className="font-primary">{'View all'}</span> */}
                    </H3>
                <UL className="activity-timeline simple-list">



                    { (notifications.length > 0) &&
                        notifications.map((notification) => 
                        (
                              <LI className="d-flex align-items-start p-0 li-hover" key={notification.ID}>
                                <div className="activity-line" />

                                <div className="flex-grow-1">
                                    <Link  className='link-not' to={`${process.env.PUBLIC_URL || ""}${notification.link_at}`} onClick={() => handleNotificationClick(notification)}>
                                        {notification.text}
                                     </Link>
                                </div>                          
                            </LI>
                        )
                        )  
                    }


                     { (notifications.length === 0) &&
                        <LI className="d-flex align-items-start p-0 li-hover" >
                            <div className="activity-line" />
                    
                            <div className="flex-grow-1">
                                Nessuna Notifica
                            </div>                          
                        </LI>
                    }


                    {/* {notificationData.map((item) => (
                        <LI className="d-flex align-items-start" key={item.id}>
                            <div className="activity-line" />
                            <div className={`activity-dot-${item.color}`} />
                            <div className="flex-grow-1">
                                <H6 className={`f-w-600 font-${item.color}`}>{item.date}
                                    <span>{item.time}</span>
                                    <span className={`circle-dot-${item.color} float-end`}>
                                        <SvgIcon className="circle-color" iconId='circle' />
                                    </span>
                                </H6>
                                <H5>{item.name}</H5>
                                <P className={item.id === 1 ? "mb-0" : ""}>{item.text}</P>
                            </div>
                        </LI>
                    ))} */}
                </UL>
            </div>
        </LI >
    )
}